module.exports = __webpack_public_path__ + "img/paypal.7152ee44.png";